// packages
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// components
import Pill from "../../../common/Pill";

// styles
import styles from "./BrokerReleaseSeller.module.scss";

const BrokerReleaseSeller = () => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName={"doneLight"}
      Lefticon={<img src={"../../../assets/images/svg/money.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_broker_release_seller_status")}
      </p>
    </Pill>
  );
};

export default BrokerReleaseSeller;
